/* eslint-disable no-unused-vars */
import { Grid, Button } from "@mui/material";
import { blue, purple, green } from "@mui/material/colors";
import PDialog from "../../components/pos/PDialog";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PSelect from "../../components/pos/PSelect";
import PText from "../../components/pos/PText";
import db from "../../db/db";
import PCheck from "../../components/pos/PCheck";
import API from "../../utils/API";
import { AgentUtils } from "../../utils/AgentUtils";
import PConfirm from "../../components/pos/PConfirm";
import { withStyles } from "@mui/styles";
import axios from "axios";

const ExportButton = withStyles((theme: Theme) => ({
  root: {
    width: "100%",
    fontSize: ".85rem",

    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
}))(Button);

export default function PDataExportView(props) {
  const { t } = useTranslation();
  const translate = t;
  const [fileOutFormatOptions, setFileOutFormatOptions] = useState([]);
  const [selectedFileOutFormat, setSelectedFileOutFormat] = useState(null);
  const [groupOptions, setGroupOptions] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [exportConfig, setExportConfig] = useState(null);
  const [configNameOptions, setConfigNameOptions] = useState([]);
  const [selectedConfigName, setSelectedConfigName] = useState(null);
  const [enableExportButton, setEnableExportButton] = useState(false);
  const [outputFilePath, setOutputFilePath] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmContext, setConfirmContext] = useState({ open: false });

  /*Custom UI Filter elements*/
  const [deptId, setDeptId] = useState(null);
  const [deptIdOptions, setDeptidOptions] = useState([]);
  const [subDeptId, setSubDeptId] = useState(null);
  const [subDeptIdOptions, setSubDeptIdOptions] = useState([]);
  const [check1, setCheck1] = useState(false);

  useEffect(() => {
    if (props.openWindow) {
      setSelectedGroup(null);
      setSelectedConfigName(null);
      if (props.dataExportConfig) {
        resetExportProfileConfig();
        populateGroupOptions();
      }
    }
  }, [props.openWindow]);

  useEffect(() => {
    populateDepartments();
  }, []);

  async function populateDepartments() {
    db.category
      .where("level")
      .equals(0)
      .toArray(function (data) {
        let dat = [];
        dat.push({
          id: "All",
          name: "All",
          code: "All",
        });
        for (let i = 0; i < data.length; i++) {
          if (!data[i].parent_id) {
            dat.push({
              id: data[i].id,
              name: data[i].name,
              code: data[i].catCode,
            });
          }
        }
        setDeptidOptions(dat);
      });
  }

  async function populateSubDept(option) {
    db.category.toArray(function (data) {
      let dat = [];
      if (option) {
        dat.push({ id: "All", name: "All" });
        for (let i = 0; i < data.length; i++) {
          if (data[i].parentId === option.id) {
            dat.push({ id: data[i].id, name: data[i].name });
          }
        }
        setSubDeptIdOptions(dat);
      }
    });
  }

  function populateGroupOptions() {
    let groupOptionsTemp = [];
    props.dataExportConfig.map((item) => {
      let config = JSON.parse(item.configTxt);
      let found = groupOptionsTemp.find((o) => o.value === config.group);
      if (found === undefined) {
        groupOptionsTemp.push({
          name: config.groupLocal,
          value: config.group,
        });
      }
    });
    setGroupOptions(groupOptionsTemp);
  }

  function populateNameOptions(group) {
    let nameOptionsTemp = [];
    props.dataExportConfig.map((item) => {
      let config = JSON.parse(item.configTxt);
      if (config.group === group) {
        let found = nameOptionsTemp.find((o) => o.value === config.name);
        if (found === undefined) {
          nameOptionsTemp.push({
            name: config.nameLocal,
            value: config.name,
          });
        }
      }
    });
    setConfigNameOptions(nameOptionsTemp);
  }

  function findExportConfig(name) {
    let configList = [];
    props.dataExportConfig.map((item) => {
      let config = JSON.parse(item.configTxt);
      if (config.name === name && config.group === selectedGroup.value) {
        configList.push(config);
      }
    });
    if (configList.length == 0) {
      props.showMessage("error", "No configuration exists!");
      return;
    }
    if (configList.length > 1) {
      props.showMessage("error", "Mor than one configuration exists!");
      return;
    }

    setExportProfileConfig(configList[0]);
  }

  function onCloseWindow() {
    props.setOpenWindow(false);
  }

  function setExportProfileConfig(config) {
    setEnableExportButton(true);
    setExportConfig(config);
    let fileOutFormatOptionsTemp = [];
    config.outFormat.map((item) => {
      fileOutFormatOptionsTemp.push(item);
    });
    setFileOutFormatOptions(fileOutFormatOptionsTemp);
  }

  function resetExportProfileConfig() {
    setEnableExportButton(false);
    setExportConfig(null);
    setFileOutFormatOptions([]);
    setSelectedFileOutFormat(null);
    setOutputFilePath("");
    setDeptId(null);
    setSubDeptId(null);
  }

  async function handleExportClick(type) {
    let copyPathFormatted = null;
    if (outputFilePath && outputFilePath != "") {
      if (outputFilePath.charAt(outputFilePath.length - 1) != "/")
        copyPathFormatted = outputFilePath + "/";
      else copyPathFormatted = outputFilePath;
    } else if (type === "EXPORT") {
      props.showMessage("error", "Export location is empty!");
      return;
    }
    let reportReq = {
      templateLocation: exportConfig.templateLocation,
      templateFileName: exportConfig.templateFileName,
      outFormat: selectedFileOutFormat.name,
      outFileExtension: selectedFileOutFormat.outFileExtension,
      outFileName: selectedFileOutFormat.exportFileName,
      paramList: [],
    };

    if (deptId && deptId.id != "All") {
      reportReq.paramList.push({
        key: "deptId",
        value: deptId.id,
        label: "Department",
        labelValue: deptId.name,
      });
    }

    if (subDeptId && subDeptId.id != "All") {
      reportReq.paramList.push({
        key: "subDeptId",
        value: subDeptId.id,
        label: "Sub Department",
        labelValue: subDeptId.name,
      });
    }

    try {
      let { data } = await API.post("/report/generate/export/data", reportReq);
      if (type === "EXPORT") {
        exportFileToLocalSystem(
          copyPathFormatted + data.filename,
          data.data,
          exportConfig.replaceFile
        );
      } else {
        //type DOWNLOAD
        downloadFile(data.filename, data.data);
      }
    } catch (e) {
      props.showMessage("error", "Error while generating the report");
      console.log("ERROR", e);
    }
  }

  async function exportFileToLocalSystem(copyPath, encodedString, replaceFile) {
    try {
      let agentIp = localStorage.getItem("agentIp");
      if (!agentIp) {
        agentIp = "localhost";
      }

      let url = "http://localhost:3337/agent/export/file";

      let payload = {
        fileName: copyPath,
        replaceFile: replaceFile,
        data: encodedString,
      };

      let result = await axios.post(url, payload);
      console.log(result);
      if (result && result.data && result.data.statusCode === "200") {
        props.showMessage("success", "Data Exported");
      } else if (result && result.data && result.data.statusCode === "403") {
        //File alredy exists
        setConfirmOpen(true);
        setConfirmContext({
          title: translate("File alredy exists"),
          message: translate(
            "The file with same name is exists in the export location, Do you want to replace the file?"
          ),
          type: "warning",
          open: true,
          yes: true,
          no: true,
          exportObject: {
            copyPath: copyPath,
            encodedString: encodedString,
            replaceFile: replaceFile,
          },
        });
      } else {
        props.showMessage(
          "error",
          "Error while saving the file in export location"
        );
      }
    } catch (e) {
      props.showMessage(
        "error",
        "Error while saving the file in export location"
      );
      console.log("ERROR", e);
    }
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      let exportObject = context.exportObject;
      exportFileToLocalSystem(
        exportObject.copyPath,
        exportObject.encodedString,
        true
      );
    }
  }

  function downloadFile(fileName, encodedString) {
    try {
      let a = document.createElement("a");
      a.href = "data:application;base64," + encodedString;
      a.download = fileName;
      a.click();
      props.showMessage("success", translate("File downloaded successfully"));
    } catch (e) {
      props.showMessage("error", "Error while downloading the file!");
      console.log("ERROR", e);
    }
  }

  const content = (
    <div>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          Export Group
        </Grid>
        <Grid item xs={6}>
          <PSelect
            options={groupOptions}
            value={selectedGroup}
            onChange={(event, newValue) => {
              resetExportProfileConfig();
              setSelectedGroup(newValue);
              setSelectedConfigName(null);
              populateNameOptions(newValue.value);
            }}
          ></PSelect>
        </Grid>
        <Grid item xs={6}>
          Config Name
        </Grid>
        <Grid item xs={6}>
          <PSelect
            options={configNameOptions}
            value={selectedConfigName}
            onChange={(event, newValue) => {
              resetExportProfileConfig();
              setSelectedConfigName(newValue);
              findExportConfig(newValue.value);
            }}
          ></PSelect>
        </Grid>
        <Grid item xs={6}>
          Output Format
        </Grid>
        <Grid item xs={6}>
          <PSelect
            options={fileOutFormatOptions}
            value={selectedFileOutFormat}
            onChange={(event, newValue) => {
              setSelectedFileOutFormat(newValue);
              if (exportConfig.exportFilePath) {
                setOutputFilePath(exportConfig.exportFilePath);
              }
            }}
          ></PSelect>
        </Grid>
        <Grid item xs={6}>
          Export Location
        </Grid>
        <Grid item xs={6}>
          <PText
            value={outputFilePath}
            onChange={(e) => setOutputFilePath(e.target.value)}
          ></PText>
        </Grid>
        {exportConfig && (
          <Grid item xs={12}>
            {exportConfig.paramList.map((paramItem) => {
              if (paramItem.key === "categorySelector") {
                return (
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      Department
                    </Grid>
                    <Grid item xs={6}>
                      <PSelect
                        options={deptIdOptions}
                        value={deptId}
                        onChange={(event, newValue) => {
                          setDeptId(newValue);
                          setSubDeptId(null);
                          populateSubDept(newValue);
                        }}
                      ></PSelect>
                    </Grid>
                    <Grid item xs={6}>
                      Sub department
                    </Grid>
                    <Grid item xs={6}>
                      <PSelect
                        options={subDeptIdOptions}
                        value={subDeptId}
                        onChange={(event, newValue) => {
                          setSubDeptId(newValue);
                        }}
                      ></PSelect>
                    </Grid>
                  </Grid>
                );
              } else if (paramItem.key === "check1") {
                return (
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      {paramItem.labelLocal
                        ? paramItem.labelLocal
                        : paramItem.label}
                    </Grid>
                    <Grid item xs={6}>
                      <PCheck
                        onChange={(value) => setCheck1(value)}
                        checked={check1}
                      ></PCheck>
                    </Grid>
                  </Grid>
                );
              }
            })}
          </Grid>
        )}
        <Grid item xs={6}>
          <Grid container direction="column" alignItems="left" justify="left">
            <Grid item xs={12}>
              <ExportButton
                disabled={!enableExportButton}
                onClick={(event) => {
                  handleExportClick("DOWNLOAD");
                }}
              >
                {translate("Download")}
              </ExportButton>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container direction="column" alignItems="right" justify="right">
            <Grid item xs={12}>
              <ExportButton
                disabled={!enableExportButton}
                onClick={(event) => {
                  handleExportClick("EXPORT");
                }}
              >
                {translate("Export")}
              </ExportButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );

  return (
    <div>
      {props.openWindow && (
        <PDialog
          content={content}
          title={
            props.windowTitle
              ? translate(props.windowTitle)
              : translate("Export Data")
          }
          maxWidth={"xs"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          mode="view"
        ></PDialog>
      )}
      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
